import type { AccountMailboxType } from 'owa-graph-schema';
import loc from 'owa-localize';
import {
    accountTypeLabel_Google,
    accountTypeLabel_iCloud,
    accountTypeLabel_Office365,
    accountTypeLabel_OutlookDotCom,
    accountTypeLabel_Other,
    accountTypeLabel_Yahoo,
} from './getProviderFromAccountType.locstring.json';
getProviderFromAccountType;

export function getProviderFromAccountType(accountType: AccountMailboxType): string {
    switch (accountType) {
        case 'OFFICE365':
            return loc(accountTypeLabel_Office365);
        case 'OUTLOOKDOTCOM':
            return loc(accountTypeLabel_OutlookDotCom);
        case 'YAHOO':
            return loc(accountTypeLabel_Yahoo);
        case 'ICLOUD':
            return loc(accountTypeLabel_iCloud);
        case 'GOOGLE':
            return loc(accountTypeLabel_Google);
        case 'OTHER':
        default:
            // End up mapping the undefined case to OTHER
            return loc(accountTypeLabel_Other);
    }
}
